<template>
  <!-- 发布研报页面 -->
  <div class="article">
    <div class="article_title">
      <el-form ref="form" :rules="rules" :model="form" label-width="107px">
        <el-form-item>
          <div class="article_top">
            <div>研报发布</div>
          </div>
        </el-form-item>
        <el-form-item label="中文标题" prop="chinese_title">
          <el-input
            style="width: 540px"
            placeholder="请输入中文标题"
            v-model="form.chinese_title"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文标题">
          <el-input
            onkeyup="this.value = this.value.replace(/[^\A-Za-z\s.]/g,'');"
            style="width: 540px"
            placeholder="可输入英文标题"
            v-model="form.english_title"
          ></el-input>
        </el-form-item>
        <el-form-item label="行业" prop="industry_name">
          <el-select
            style="width: 200.1px"
            v-model="form.industry_name"
            placeholder="请选择行业"
            @change="selectSubjectItem($event)"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="{ code: item.id, labels: item.name }"
            />
          </el-select>
        </el-form-item>
        <div class="op">
          <el-form-item label="是否收费" prop="is_charge">
            <el-select
              style="width: 200.1px"
              v-model="form.is_charge"
              placeholder="请选择"
            >
              <el-option
                v-for="item in status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <div v-if="form.is_charge == '1'">
            <el-form-item label="价格(RMB)">
              <el-input
                onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                style="width: 132px"
                placeholder="请输入价格"
                v-model="form.price"
              ></el-input>
              <span class="apo">元</span>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="来源">
          <el-input
            style="width: 201px"
            placeholder="请输入来源"
            v-model="form.com_on"
          ></el-input>
        </el-form-item>
        <div style="display:flex;position:relative">
          <span style="color:#F56C6C;position: absolute;color: red;top: 11px;"
            >*</span
          >
          <el-form-item label="上传研报文件">
            <div class="HeadPortrait">
              <el-upload
                accept=".pdf"
                class="Enterprise_LoGo_img"
                action="https://researchadmin.qudong.com/api/upload/upload_pdf"
                :headers="headers"
                :show-file-list="false"
                multiple
                name="image"
                :on-success="successAgreements"
                :before-upload="beforeRef"
              >
                <div class="enterpriso">
                  <div v-if="imageUrls" class="Enterprise_LoGos">
                    <div class="Enterprise_LoGosimg">
                      <img src="../../assets/img/pdf.png" />
                      <img
                        class="Enterprise_LoGosimg_right"
                        src="../../assets/img/pnficon.png"
                        @click.stop="queryFile"
                      />
                    </div>
                    <div>
                      <span class="Enterprise_LoGosimg_text">{{ file }}</span>
                    </div>
                  </div>
                  <i v-else class="el-icon-plus Enterprise_LoGo_img_icon"></i>
                </div>
              </el-upload>
              <span class="span_text"
                >请上传大小不能超过500M。支持格式：.pdf</span
              >
            </div>
          </el-form-item>
        </div>

        <el-form-item label="简介" prop="report_profile">
          <el-input
            style="width: 540px;height: 80px;"
            placeholder="请输入200字以内简介..."
            type="textarea"
            :rows="3"
            resize="none"
            maxlength="200"
            v-model="form.report_profile"
          ></el-input>
        </el-form-item>
        <el-form-item label="目录章节" prop="contents_section">
          <el-input
            class="ariticle_button"
            style="width: 540px;height:120px"
            placeholder="请提供所有目录章节（10000字以内）..."
            type="textarea"
            :rows="5"
            resize="none"
            maxlength="10000"
            v-model="form.contents_section"
          ></el-input>
        </el-form-item>
        <div style="display:flex;position:relative">
          <span
            style="color:#F56C6C;position: absolute;color: red;top: 11px;left: 15px;"
            >*</span
          >
          <el-form-item label=" 上传缩略图">
            <div class="HeadPortrait_text">
              <el-upload
                class="Enterprise_LoGo_img"
                action="https://researchadmin.qudong.com/api/upload/upload_img"
                :headers="headers"
                :show-file-list="false"
                multiple
                name="image"
                :on-success="successAgreements_text"
                :before-upload="beforeRef_text"
              >
                <img
                  v-if="images"
                  :src="images"
                  class="Enterprise_LoGos_text"
                />
                <i v-else class="el-icon-plus Enterprise_LoGo_img_icon"></i>
              </el-upload>
              <span>请上传大小不能超过2M。支持格式：.jpg、.png、.jpeg</span>
            </div>
          </el-form-item>
        </div>
        <el-form-item>
          <div class="article_button">
            <el-button @click="onSubmit">提交审核</el-button>
            <el-button @click="onSubmits">保存草稿</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  article_report,
  type_list,
  article_updatedata,
  userInfos,
} from "../../api/api";
let token = localStorage.getItem("token");
export default {
  metaInfo() {
    return {
      title: "研报发布",
      meta: [
        {
          name: "keywords",
          content:
            "驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。",
        },
        {
          name: "description",
          content:
            " 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网",
        },
      ],
    };
  },
  name: "ResearchReport",
  created() {
    this.qulist();
    this.query();
    userInfos({}).then((res) => {
      ////console.log(res);
      //  0普通
      // 1专家
      // 2机构
      var isbusiness = res.data.data.business;
      if (isbusiness == 0) {
        this.$confirm("您认证的信息还未通过暂时无法发布", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          })
          .catch(() => {
            this.$router.push({ path: "/PersonalCenter/index" });
          });
      }
    });
  },
  data() {
    return {
      typeList: [],
      headers: {
        token: token,
      }, //请求头传token
      value2: "",
      file: "",
      rows: "",
      imageUrls: "", //研报文件
      images: "", //上传照片
      form: {
        com_on: "", //来源
        price: "", //价格
        english_title: "", //英文标题
        chinese_title: "", //中文标题
        is_charge: "", //是否收费
        industry_name: "", //行业
        industry_id: "", //行业id
        report_profile: "", // 简介
        contents_section: "", // 目录章节
      },
      status: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      rules: {
        chinese_title: [
          { required: true, message: "请输入中文标题", trigger: "change" },
        ],
        is_charge: [
          { required: true, message: "请选择是否收费", trigger: "change" },
        ],
        industry_name: [
          { required: true, message: "请选择行业类型", trigger: "change" },
        ],
        report_profile: [
          { required: true, message: "请输入简介", trigger: "change" },
        ],
        contents_section: [
          { required: true, message: "请输入目录文章", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 接收过来的值
    query() {
      let id = this.$route.query.id;
      let type = this.$route.query.type;
      if (this.$route.query.id != undefined) {
        article_updatedata({
          id: id,
          type: type,
        }).then((res) => {
          let querylist = res.data.data;
          ////console.log(res);
          this.form.com_on = querylist.com_on;
          this.form.chinese_title = querylist.chinese_title;
          this.form.english_title = querylist.english_title;
          this.form.industry_id = querylist.industry_id;
          this.form.industry_name = querylist.industry_name;
          this.form.is_charge = querylist.is_charge;
          this.form.price = querylist.price;
          this.imageUrls = querylist.report_file;
          this.form.report_profile = querylist.report_profile;
          this.form.contents_section = querylist.contents_section;
          this.images = querylist.img;
          this.file = querylist.file_name;
        });
      }
    },
    queryFile() {
      this.imageUrls = "";
    },
    selectSubjectItem(event) {
      this.form.industry_id = event.code; // 赋值给后端需要的字段
      this.form.industry_name = event.labels; // 赋值给后端需要的字段
    },
    qulist() {
      type_list({}).then((res) => {
        this.typeList = res.data.data;
      });
    },
    // 保存草稿
    onSubmits() {
      ////console.log(this.form.com_on);
      if (this.imageUrls == "") {
        this.$message.error("请上传文件");
        return false;
      }
      if (this.images == "") {
        this.$message.error("请上传缩略图");
        return false;
      }
      let id = this.$route.query.id;
      if (id == undefined) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.is_charge == 0) {
              this.form.price = null;
            }
            article_report({
              chinese_title: this.form.chinese_title,
              english_title: this.form.english_title,
              industry_id: this.form.industry_id,
              industry_name: this.form.industry_name,
              is_charge: this.form.is_charge,
              price: this.form.price,
              com_on: this.form.com_on,
              report_file: this.imageUrls,
              report_profile: this.form.report_profile,
              contents_section: this.form.contents_section,
              img: this.images,
              file_name: this.file,
              status: 3,
            }).then((res) => {
              this.$message.success("保存成功");
              if (res.data.code == 200) {
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.is_charge == 0) {
              this.form.price = null;
            }
            article_report({
              id: id,
              chinese_title: this.form.chinese_title,
              english_title: this.form.english_title,
              industry_id: this.form.industry_id,
              industry_name: this.form.industry_name,
              is_charge: this.form.is_charge,
              price: this.form.price,
              com_on: this.form.com_on,
              report_file: this.imageUrls,
              report_profile: this.form.report_profile,
              contents_section: this.form.contents_section,
              img: this.images,
              file_name: this.file,
              status: 3,
            }).then((res) => {
              this.$message.success("保存成功");
              if (res.data.code == 200) {
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      }
    },
    //提交审核
    onSubmit() {
      ////console.log(this.form.com_on);
      if (this.imageUrls == "") {
        this.$message.error("请上传文件");
        return false;
      }
      if (this.images == "") {
        this.$message.error("请上传缩略图");
        return false;
      }
      let id = this.$route.query.id;
      if (id == undefined) {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.is_charge == 0) {
              this.form.price = null;
            }
            article_report({
              chinese_title: this.form.chinese_title,
              english_title: this.form.english_title,
              industry_id: this.form.industry_id,
              industry_name: this.form.industry_name,
              is_charge: this.form.is_charge,
              price: this.form.price,
              com_on: this.form.com_on,
              report_file: this.imageUrls,
              report_profile: this.form.report_profile,
              contents_section: this.form.contents_section,
              img: this.images,
              file_name: this.file,
            }).then((res) => {
              this.$message.success("发布成功");
              if (res.data.code == 200) {
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      } else {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            if (this.form.is_charge == 0) {
              this.form.price = null;
            }
            article_report({
              id: id,
              chinese_title: this.form.chinese_title,
              english_title: this.form.english_title,
              industry_id: this.form.industry_id,
              industry_name: this.form.industry_name,
              is_charge: this.form.is_charge,
              price: this.form.price,
              com_on: this.form.com_on,
              report_file: this.imageUrls,
              report_profile: this.form.report_profile,
              contents_section: this.form.contents_section,
              img: this.images,
              file_name: this.file,
            }).then((res) => {
              this.$message.success("修改成功");
              if (res.data.code == 200) {
                setTimeout(() => {
                  this.$router.push("/PersonalCenter/Releases");
                }, 1500);
              }
            });
          }
        });
      }
    },
    // 上传图片
    successAgreements_text(res) {
      var that = this;
      ////console.log(res);
      that.images = res.data;
    },
    // 请求前限制上传条件
    beforeRef_text(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG || !isLt2M) {
        this.$message.error("上传文件只能是图片格式，且大小不能超过2M");
      }
      return isJPG, isLt2M;
    },
    // 上传pdf
    successAgreements(res) {
      ////console.log(res);
      var that = this;
      that.imageUrls = res.data;
    },
    // 请求前限制上传条件
    beforeRef(file) {
      ////console.log(file);
      this.file = file.name;
      const isJPG = file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 500;
      if (!isJPG || !isLt2M) {
        this.$message.error("上传文件只能是pdf格式，且大小不能超过500M");
        return false;
      }
      return isJPG, isLt2M;
    },
  },
};
</script>

<style scoped>
.article {
  width: 940px;
  background-color: #fff;
}
.op {
  width: 650px;
  display: flex;
  justify-content: space-between;
}
.apo {
  margin-left: 10px;
}
.article >>> .el-icon-plus:before {
  content: none;
}
.article >>> .el-select-dropdown__item:selected {
  color: #f0f0f0 !important;
}
.HeadPortrait {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.HeadPortrait .span_text {
  margin-left: 20px;
  margin-top: 77px;
}
.HeadPortrait .Enterprise_LoGo_img {
  width: 121px;
  height: 124px;
  cursor: pointer;
  background-image: url("../../assets/img/article.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Enterprise_LoGo_img .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
}
.Enterprise_LoGo_img .el-upload:hover {
  border-color: #409eff;
}
.Enterprise_LoGo_img_icon {
  font-size: 28px;
  color: #8c939d;
  width: 121px;
  height: 124px;
}
.Enterprise_LoGos {
  height: 124px;
  display: block;
  background: #f0f0f0;
}
.Enterprise_LoGosimg {
  display: flex;
  justify-content: space-around;
  width: 52px;
  padding-top: 19px;
  margin-left: 40px;
  margin-bottom: 9px;
}
.Enterprise_LoGosimg_right {
  width: 10px;
  height: 10px;
}
.Enterprise_LoGosimg_text {
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
  word-break: break-word;
}
.enterpriso {
  width: 120px;
  height: 124px;
  margin: 0 auto;
}
.el-button {
  border: 1px solid #999999;
  color: #999999;
  border-radius: 10px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  margin-right: 60px;
  margin-left: 60px;
}
.article >>> .el-form-item__content {
  line-height: 16px;
}
.el-button {
  width: 120px;
  height: 48px;
}
.article >>> .el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}
.article_top > div {
  width: 540px;
  text-align: center;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-top: 39px;
}
.article_button {
  width: 540px;
  text-align: center;
  margin-top: 30px;
}
.article_up {
  display: flex;
  height: 124px;
}
.article_img {
  width: 121px;
  height: 124px;
  margin-right: 20px;
}
.article_title {
  margin-left: 49px;
}
/* 上传缩略图 */
.HeadPortrait_text {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.HeadPortrait_text span {
  margin-left: 20px;
  margin-top: 77px;
}
.HeadPortrait_text .Enterprise_LoGo_img {
  width: 121px;
  height: 124px;
  cursor: pointer;
  background-image: url("../../assets/img/article.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Enterprise_LoGos_text {
  width: 121px;
  height: 124px;
  display: block;
  background: #fff;
}
</style>